function transformCurrentSessionSecurity(security, talentSession) {
    const currentSession = security.current_session;
    return {
        applicationRoles: currentSession.application_roles || [],
        applicationProducts: currentSession.application_products || [],
        applicationPermissions: currentSession.application_permissions || [],
        centralizedSession: {
            centralizedUserId: currentSession.centralized_session.centralized_user_id,
            centralizedOrganizationId: currentSession.centralized_session.centralized_organization_id,
            centralizedOrganizationSlug: currentSession.centralized_session.centralized_organization_slug,
            centralizedUserOrganizationId: currentSession.centralized_session.centralized_user_organization_id,
            centralizedUserOrganizationRole: currentSession.centralized_session.centralized_user_organization_role,
            centralizedUserCountryCode: currentSession?.centralized_session?.centralized_user_country_code ?? void 0
        },
        talentSession: currentSession?.talent_session && talentSession ? {
            companyId: currentSession.talent_session.company_id,
            employeeId: currentSession.talent_session.employee_id,
            userId: currentSession.talent_session.user_id,
            userRole: currentSession.talent_session.user_role,
            flexSidToken: talentSession.flex_sid_token,
            urlParent: talentSession.url_parent,
            userParentId: talentSession.user_parent_id
        } : void 0,
        learningSession: currentSession?.learning_session ? {
            userId: currentSession.learning_session.user_id,
            organizationId: currentSession.learning_session.organization_id,
            organizationSlug: currentSession.learning_session.organization_slug,
            userOrganizationId: currentSession.learning_session.user_organization_id,
            userOrganizationRole: currentSession.learning_session.user_organization_role
        } : void 0
    };
}
export { transformCurrentSessionSecurity };
